import { ArrowLeft, ArrowRight } from "lucide-react";
import React from "react";

const Pagination = ({ currentPage, totalCount, rowsPerPage, onPageChange }) => {
  // Calculate pagination values internally
  const totalPages = rowsPerPage > 0 ? Math.ceil(totalCount / rowsPerPage) : 1;

  // Calculate range of visible page buttons
  const getPageNumbers = () => {
    const delta = 1;
    let range = [];

    // Always include page 1
    range.push(1);

    // Calculate start and end of range
    const rangeStart = Math.max(2, currentPage - delta);
    const rangeEnd = Math.min(totalPages - 1, currentPage + delta);

    // Add ellipsis after page 1 if needed
    if (rangeStart > 2) {
      range.push("...");
    }

    // Add pages in the middle of the range
    for (let i = rangeStart; i <= rangeEnd; i++) {
      range.push(i);
    }

    // Add ellipsis before last page if needed
    if (rangeEnd < totalPages - 1) {
      range.push("...");
    }

    // Always include last page if there is more than one page
    if (totalPages > 1) {
      range.push(totalPages);
    }

    return range;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex items-center justify-between w-full">
      {/* Show range if enabled */}
      {/* {showRange && totalCount > 0 && (
        <div className="text-xs text-gray-500">
          Showing{" "}
          <span className="font-semibold text-gray-800">
            {startIndex}-{endIndex}
          </span>{" "}
          of <span className="font-semibold text-gray-800">{totalCount}</span>
        </div>
      )} */}

      <div className="inline-flex rounded-md ml-auto text-xs shadow-sm border border-gray-300 dark:border-gray-800">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="font-semibold gap-2 text-xs px-4 py-2 text-gray-800 dark:text-gray-100 bg-white dark:bg-gray-900 rounded-l-lg hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
        >
          <ArrowLeft size={18} className="text-gray-700 dark:text-gray-300" />
          Previous
        </button>

        {pageNumbers.map((page, index) => (
          <React.Fragment key={index}>
            {page === "..." ? (
              <span className="px-4 py-2 text-gray-600 dark:text-gray-400 bg-white dark:bg-gray-900 border-l border-gray-300 dark:border-gray-800 flex items-center justify-center">
                ...
              </span>
            ) : (
              <button
                onClick={() => onPageChange(page)}
                className={`font-medium px-4 py-2 border-l border-gray-300 dark:border-gray-800 ${
                  currentPage === page
                    ? "bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-100"
                    : "bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                }`}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="font-semibold gap-2 px-4 py-2 text-gray-800 dark:text-gray-100 border-l border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-r-lg hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
        >
          Next
          <ArrowRight size={18} className="text-gray-700 dark:text-gray-300" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
